import { defineComponent, onMounted, ref, reactive, computed, watch } from 'vue'
import Input from 'ant-design-vue/lib/input'
import Select from 'ant-design-vue/lib/select'
import Drawer from 'ant-design-vue/lib/drawer'
import Form from 'ant-design-vue/lib/form'
import Radio from 'ant-design-vue/lib/radio'
import Button from 'ant-design-vue/lib/button'
import Checkbox from 'ant-design-vue/lib/checkbox'

const str = `函数形式
function Get(data) {
    // 处理逻辑, format为固定函数名,data为接口返回的参数，必须有返回值
    data.code = 0;
    data.msg = 'error'
    return data;
}
返回值形式
{
    code: 0,
    msg: 'error'
}
`
const json = { type: 'add',key: '', value: '' };
const Interceptor = defineComponent((props: any) => {

    const data = reactive({
        visible: false,
        returnType: 'system',
        returnData: '',
        status: '',
        timeout: '',
        url: '',
        method: 'get',
        uid: '',
        mock: false,
        disabled: false
    })
    const headers = ref<any>([ {...json} ]);
    const query = ref<any>([ {...json} ]);
    const body = ref<any>([ {...json} ]);

    const clear = () => {
        data.returnType = 'system';
        data.timeout = '';
        data.status = '';
        data.url = '';
        data.returnData = '';
        data.method = 'get';
        data.mock = false;
        data.disabled = false;
        headers.value = [{...json}];
        query.value = [{...json}];
        body.value = [{...json}];
        data.uid = '';
    }

    const submit = () => {
        if (data.mock == true && !data.returnData) {
            return alert('不走真实接口情况下，必须定义返回值')
        }
        if (!data.url) {
            return alert('请定义请求路径')
        }
        const _data = {
            headers: headers.value.filter((v: any) => v.key),
            query: query.value.filter((v: any) => v.key),
            body: body.value.filter((v: any) => v.key),
            status: data.status,
            timeout: data.timeout,
            returnType: data.returnType,
            returnData: data.returnData,
            url: data.url.trim(),
            method: data.method,
            mock: data.mock,
            disabled: data.disabled,
            uid: data.uid
        }
        const formData = new FormData();
        formData.append('headers', JSON.stringify(_data.headers));
        formData.append('query', JSON.stringify(_data.query));
        formData.append('body', JSON.stringify(_data.body));
        formData.append('status', data.status);
        formData.append('timeout', data.timeout as any);
        formData.append('returnType', data.returnType);
        formData.append('returnData', data.returnData);
        formData.append('url', data.url.trim());
        formData.append('method', data.method);
        formData.append('uid', data.uid);
        formData.append('mock', data.mock as any);
        formData.append('disabled', data.disabled as any);
        fetch(`${process.env.VUE_APP_BASE_API}/${localStorage.getItem('username')}/interceptor`, {
            method: 'post', body: formData
        })
        .then(v => v.json()).then(v => {
            if (v.code == 0) {
                alert(v.msg)
                return;
            }
            _data.uid = v.uid;
            props.onSuccess && props.onSuccess(_data);
            setTimeout(() => {
                clear();
            }, 300);
        })
    }

    watch(() => props.content, () => {
        if (props.content != null){
            data.method = props.content.method;
            data.url = props.content.url;
            data.returnType = props.content.returnType;
            data.returnData = props.content.returnData;
            data.timeout = props.content.timeout;
            data.mock = props.content.mock;
            data.status = props.content.status;
            data.disabled = props.content.disabled
            headers.value = props.content.headers;
            query.value = props.content.query;
            data.uid = props.content.uid;
            body.value = props.content.body;
        }
    }, {
        deep: true
    })

    const buildInput = (el: any) => {
        return el.value.map((v: any, index: any) => <div style={{display: 'flex', marginBottom: '0px'}} >
            <Select value={el.value[index].type} onChange={val => {
                el.value[index].type = val;
            }}>
                <Select.Option value='add' key='add'>
                    追加
                </Select.Option>
                <Select.Option value='delete' key='delete'>
                    删除
                </Select.Option>
            </Select>&nbsp;
            <Input value={el.value[index].key} style={{height: '32px'}} placeholder='key' onChange={val => {
                el.value[index].key = val.target.value
            }} />&nbsp;
            <Input value={el.value[index].value} style={{height: '32px'}} placeholder='value' onChange={val => {
                el.value[index].value = val.target.value
            }}/>
        </div>);
    }

    return () => <Drawer visible={props.visible} onClose={() => {
        props.onClose && props.onClose();
        setTimeout(() => {
            clear();
        }, 300);
    }} width='550px'>
        <Form style={{width: '460px'}} label-col={{span: 5}} wrapper-col={{span: 19}}>
            <Form.Item label='请求方式'>
                <Select value={data.method} onChange={val => {
                    data.method = val;
                }}>
                    <Select.Option key='get' value='get'>get</Select.Option>
                    <Select.Option key='post' value='post'>post</Select.Option>
                    <Select.Option key='delete' value='delete'>delete</Select.Option>
                    <Select.Option key='put' value='put'>put</Select.Option>
                    <Select.Option key='head' value='head'>head</Select.Option>
                </Select>
            </Form.Item>
            <Form.Item label='url'>
                <Input value={data.url} placeholder='请求地址' onChange={e => {
                    data.url = e.target.value
                }} />
            </Form.Item>
            <Form.Item label='headers'>
                {buildInput(headers)}
                <Button onClick={() => {
                    headers.value.push({...json})
                }}>增加</Button>
            </Form.Item>
            <Form.Item label='body'>
                {buildInput(body)}
                <Button onClick={() => {
                    body.value.push({...json})
                }}>增加</Button>
            </Form.Item>
            <Form.Item label='query'>
                {buildInput(query)}
                <Button onClick={() => {
                    query.value.push({...json})
                }}>增加</Button>
            </Form.Item>
            <Form.Item label='状态码'>
                <Input value={data.status} placeholder='默认接口返回状态码' onChange={e => {
                    data.status = e.target.value
                }} />
            </Form.Item>
            <Form.Item label='延迟'>
                <Input value={data.timeout} placeholder='单位ms(毫秒)' onChange={e => {
                    data.timeout = e.target.value
                }} />
            </Form.Item>
            <Form.Item label='Mock'>
                <Checkbox checked={data.mock} onChange={e => {
                    data.mock = e.target.checked
                }} >
                    是否走仿真环境
                </Checkbox>
                <div style={{lineHeight: '20px', fontSize: '13px', color: '#666'}}>
                    如果勾选，拦截到此接口直接返回定义的返回值，而不走真实接口
                </div>
            </Form.Item>
            <Form.Item label='是否启用'>
                <Checkbox checked={!data.disabled} onChange={e => {
                    data.disabled = !e.target.checked
                }} >
                    {data.disabled ? '否' : '是'}
                </Checkbox>
            </Form.Item>
            <Form.Item label='返回值'>
                <Radio.Group value={data.returnType} onChange={val => {
                    data.returnType = val.target.value
                }}>
                    <Radio value='system'>系统</Radio>
                    <Radio value='text'>返回值形式</Radio>
                    <Radio value='function'>函数形式</Radio>
                </Radio.Group>
                <Input.TextArea v-show={data.returnType != 'system'} placeholder={str} value={data.returnData} auto-size onChange={val => {
                    data.returnData = val.target.value
                }} />
            </Form.Item>
            <div style='text-align: center'>
                <Button type='primary' onClick={submit}>保存</Button>
            </div>
        </Form>
    </Drawer>
})
Interceptor.props = {
    visible: Boolean,
    onClose: Function,
    onSuccess: Function,
    content: Object
}
export default Interceptor;